const getAvailableFilters = ({ report: { filters } }, dataKey) => ({
  availableFilters: filters.options.available[dataKey],
});

export default getAvailableFilters;
